import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { errorText } from "@/components/coaching/GuidedDay";

export const GameDayVenue = ({ plan, setPlan }) => {
  const [q, setQ] = useState(""), [rows, setRows] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return undefined; }
    const t = setTimeout(() => api.get("/venues", { params: { sport: plan.sport, q, limit: 8 } }).then((r) => setRows(r.data.venues)).catch(() => setRows([])), 300);
    return () => clearTimeout(t);
  }, [q, plan.sport]);
  const weatherFor = async (v, day) => {
    if (v.lat == null || !day || v.setting === "indoor") return null;
    try { return (await api.get("/venues/weather", { params: { lat: v.lat, lon: v.lon, day } })).data; } catch (e) { toast.error(errorText(e)); return null; }
  };
  const pick = async (v) => {
    const venue = { venue_id: v.venue_id, name: v.name, city: v.city, country: v.country, setting: v.setting, elevation_m: v.elevation_m, surface: v.surface, lat: v.lat, lon: v.lon };
    setPlan({ ...plan, venue, weather: await weatherFor(venue, plan.date) });
    setQ(""); setRows([]);
  };
  useEffect(() => {
    if (!plan.venue?.name || plan.weather?.day === plan.date) return;
    weatherFor(plan.venue, plan.date).then((weather) => setPlan((cur) => ({ ...cur, weather })));
  }, [plan.date]); // eslint-disable-line react-hooks/exhaustive-deps
  const v = plan.venue || {};
  return (
    <div className="space-y-3" data-testid="gameday-venue">
      <h3 className="font-heading font-bold">Venue</h3>
      {v.name ? <p className="text-sm" data-testid="gameday-venue-name">{[v.name, v.city, v.country].filter(Boolean).join(", ")}{v.setting ? ` · ${v.setting}` : ""}{v.elevation_m != null ? ` · ${v.elevation_m} m` : ""}</p> : <p className="text-sm text-muted-foreground">No venue chosen.</p>}
      <input data-testid="gameday-venue-search" className="inp" placeholder="Search for the venue" value={q} onChange={(e) => setQ(e.target.value)} />
      {rows.length > 0 && <ul className="border border-border divide-y divide-border">{rows.map((r) => <li key={r.venue_id}><button data-testid={`gameday-venue-pick-${r.venue_id}`} className="w-full text-left px-3 py-2 text-sm hover:bg-surface transition-colors" onClick={() => pick(r)}>{[r.name, r.city, r.country].filter(Boolean).join(", ")}</button></li>)}</ul>}
      {v.name && !plan.date && <p className="text-xs text-muted-foreground" data-testid="gameday-venue-nodate">Add the match date to include the weather.</p>}
      {plan.weather && <p className="text-xs text-muted-foreground" data-testid="gameday-weather">{`${plan.weather.kind === "forecast" ? "Forecast" : "Typical weather"}: feels like ${plan.weather.apparent_temperature_max}°C, wind ${plan.weather.wind_speed_10m_max} km/h, rain ${plan.weather.precipitation_sum} mm.`}</p>}
      {(plan.venue_notes || []).length > 0 && <ul className="list-disc pl-5 text-sm space-y-1" data-testid="gameday-venue-notes">{plan.venue_notes.map((n) => <li key={n}>{n}</li>)}</ul>}
      {v.name && !(plan.venue_notes || []).length && <p className="text-xs text-muted-foreground">Save to see what to adjust for this venue.</p>}
    </div>
  );
};
